var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-lg-8" }, [
      _c("div", { staticClass: "dashboard-block" }, [
        _c("h2", [_vm._v("Invoices")]),
        _vm._v(" "),
        _c("ul", { staticClass: "item-detail item-detail-payment" }, [
          _c(
            "li",
            [_c("invoice-item", { attrs: { booking: _vm.booking } })],
            1
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-lg-4" }, [
      _c(
        "div",
        { staticClass: "dashboard-block" },
        [
          _vm.helpSteps.length
            ? _c("help-steps", { attrs: { steps: _vm.helpSteps } })
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }